import PressVM from './press-vm';
export default {
  init: function(node){
    console.log('Initializing Kadenze.Press');

    var params = $('#archived-articles').val();

    ko.applyBindings(new PressVM(params), node);
  }
};







